import React, { useContext, useEffect, useState } from "react";
import "./styles.scss";
import NrwService from "../../domain/Nrw/NrwService";

import NonRevenueWaterService from "@/domain/NonRevenueWater/NonRevenueWaterService";

import DashboardContext from "@/contexts/DashboardContext";
import { DatePicker, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";

const nrwService = new NrwService();
const nonRevenueWaterService = new NonRevenueWaterService();
const { RangePicker } = DatePicker;
interface Invoice {
  nrwInvoiceId: number;
  startDate: string;
  endDate: string;
  value: number;
  tag: string;
}

export default function DashobardNrwView() {
  const { value: context } = useContext(DashboardContext);
  const [dashboardData, setdashboardData] = useState<any>(null);
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice | null>(null);

  
  async function handleGetNonNrw() {
  if (!context.selectedLocation) return;
  try {
    const locationId = Number(context.selectedLocation);
    const response = await nonRevenueWaterService.getConfiguration(locationId);

    if (response && response.invoice) {
      setInvoices(response.invoice);
      if (response.invoice.length > 0) {
        const firstInvoice = response.invoice[0];
        setSelectedInvoice(firstInvoice);
        const formattedStart = firstInvoice.startDate.split(' ')[0];
        const formattedEnd = firstInvoice.endDate.split(' ')[0];
        handleGetNewNrwates(formattedStart, formattedEnd);
      }
    } else {
      console.warn("No data returned from NonRevenueWater service");
      setdashboardData(null);
    }
  } catch (error) {
    console.error("Error fetching NonRevenueWater config:", error);
    setdashboardData(null);
  }
}

  const handleInvoiceSelect = (invoice: Invoice) => {
    setSelectedInvoice(invoice);
    const formattedStart = invoice.startDate.split(' ')[0];
    const formattedEnd = invoice.endDate.split(' ')[0];

    console.log("Using dates:", {
      start: formattedStart,
      end: formattedEnd
    });

    handleGetNewNrwates(formattedStart, formattedEnd);
  };
  const invoiceMenu = (
    <Menu>
      {invoices.map((invoice) => (
        <Menu.Item
          key={invoice.nrwInvoiceId}
          onClick={() => handleInvoiceSelect(invoice)}
        >
          <div style={{ padding: '8px 12px' }}>
            <div style={{ fontWeight: 500 }}>{invoice.tag}</div>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  async function handleGetNewNrwates(startDate: string, endDate: string) {
    if (!context.selectedLocation) {
      console.warn("No location selected.");
      return;
    }

    try {
      console.log(`Fetching NRW data for location: ${context.selectedLocation}`);
      const response = await nrwService.getNRWDates(
        context.selectedLocation,
        startDate,
        endDate
      );

      if (response && response.data) {
        const data = JSON.parse(response.data) as { [key: string]: any };

        const processedData = Object.keys(data).reduce((acc, key) => {
          acc[key] = data[key] ?? "-";
          return acc;
        }, {} as { [key: string]: any });

        console.log("New NRW data fetched successfully:", processedData);
        setdashboardData(processedData);
      } else {
        console.warn("No data returned from service.");
        setdashboardData(null);
      }
    } catch (error) {
      console.error("Error fetching NRW dates:", error);
      setdashboardData(null);
    }
  }


  useEffect(() => {
    handleGetNonNrw();
  }, [context.selectedLocation]);

  return (
    <div>
      <div style={{ marginTop: "70px" }}>
        <div className="dashboard-nrw" style={{ marginBottom: "20px", display: 'none' }}>
          <p className="mt-1 pl-2">Use Custom Invoice</p>
          <RangePicker
            style={{ marginLeft: 30, width: 300 }}
            onChange={(dates, dateStrings) => {
              if (dateStrings && dateStrings[0] && dateStrings[1]) {
                console.log("Selected dates:", dateStrings);
                handleGetNewNrwates(dateStrings[0], dateStrings[1]);
                setSelectedInvoice(null);
              } else {
                console.warn("Invalid or incomplete date range selected.");
              }
            }}
          />
        </div>
        {invoices.length > 0 && (
          <div style={{
            display: "flex",
            alignItems: "center",
            width: "350px",
            marginTop: "20px"
          }}>
            <p className="mt-1 pl-2" style={{ minWidth: "120px" }}>Data Range:</p>
            <Dropdown overlay={invoiceMenu} trigger={['click']}>
              <div style={{
                width: "100%",
                padding: "8px 15px",
                border: "1px solid #d9d9d9",
                borderRadius: "4px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}>
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {selectedInvoice ? selectedInvoice.tag : 'Select period'}
                </span>
                <DownOutlined style={{ marginLeft: "8px" }} />
              </div>
            </Dropdown>
          </div>
        )}
      </div>
      <div className="dashboard-nrw" style={{ marginTop: "10px", height: "calc(100vh - 120px)" }}>
        <div className="column-dashboard column-other">
          <div className="section-dashboard full-height t-b">
            <span className="title">System Input Volume</span>
            <span className="value">
              {dashboardData?.waterSupplied ? `${dashboardData.waterSupplied.toLocaleString('en-US')} m3` : '-'}
            </span>

          </div>
        </div>

        <div className="column-dashboard column-other">
          <div className="section-dashboard half-height t-b">
            <span className="title">Authorized Consumption</span>
            <span className="value">
              {dashboardData?.authorizedConsumption ? `${dashboardData.authorizedConsumption.toLocaleString('en-US')} m3` : '-'}
            </span>
          </div>

          <div className="section-dashboard half-height t-l">
            <span className="title">Water Losses</span>
            <span className="value">
              {dashboardData?.waterLosses ? `${dashboardData.waterLosses.toLocaleString('en-US')} m3` : '-'}
            </span>
          </div>
        </div>
        <div className="column-dashboard column-real-losses">
          <div className="section-dashboard quarter-height double-section">
            <div className="quarter-height half-width column-body-left t-b">
              <span className="title">Billed Authorized Consumption</span>
              <span className="value low">
                {dashboardData?.billedAuthorizedConsumption ? `${dashboardData.billedAuthorizedConsumption.toLocaleString('en-US')} m3` : '-'}
              </span>
            </div>

            <div className="quarter-height half-width column-body">
              <div className="section-dashboard-child half-height top t-b">
                <div className="column-body">
                  <span className="title">Billed Metered Consumption</span>
                  <span className="value low">
                    {dashboardData?.billedMeteredConsumption ? `${dashboardData.billedMeteredConsumption.toLocaleString('en-US')} m3` : '-'}
                  </span>
                </div>
              </div>

              <div className="section-dashboard-child half-height bottom t-b">
                <div className="column-body">
                  <span className="title">Billed Unmetered Consumption</span>
                  <span className="value low">
                    {dashboardData?.billedUnmeteredConsumption ? `${dashboardData.billedUnmeteredConsumption.toLocaleString('en-US')} m3` : '-'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="section-dashboard quarter-height double-section">
            <div className="quarter-height half-width column-body-left t-l">
              <span className="title">Unbilled Authorized Consumption</span>
              <span className="value low">
                {dashboardData?.unbilledAuthorizedConsumption ? `${dashboardData.unbilledAuthorizedConsumption.toLocaleString('en-US')} m3` : '-'}
              </span>
            </div>

            <div className="quarter-height half-width column-body">
              <div className="section-dashboard-child half-height top t-l">
                <div className="column-body">
                  <span className="title">Unbilled Metered Consumption</span>
                  <span className="value low">
                    {dashboardData?.unbilledMeteredConsumption ? `${dashboardData.unbilledMeteredConsumption.toLocaleString('en-US')} m3` : '-'}
                  </span>
                </div>
              </div>

              <div className="section-dashboard-child half-height bottom t-l">
                <div className="column-body">
                  <span className="title">Unbilled Unmetered Consumption</span>
                  <span className="value low">
                    {dashboardData?.unbilledUnmeteredConsumption ? `${dashboardData.unbilledUnmeteredConsumption.toLocaleString('en-US')} m3` : '-'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="section-dashboard quarter-height double-section">
            <div className="quarter-height half-width column-body-left t-l">
              <span className="title">Apparent Losses</span>
              <span className="value low">
                {dashboardData?.apparentLosses ? `${dashboardData.apparentLosses.toLocaleString('en-US')} m3` : '-'}
              </span>
            </div>

            <div className="quarter-height half-width column-body">
              <div className="section-dashboard-child half-height top t-l">
                <div className="column-body">
                  <span className="title">Unauthorized Consumption</span>
                  <span className="value low">
                    {dashboardData?.unauthorizedConsumption ? `${dashboardData.unauthorizedConsumption.toLocaleString('en-US')} m3` : '-'}
                  </span>
                </div>
              </div>

              <div className="section-dashboard-child half-height bottom t-l">
                <div className="column-body">
                  <span className="title">Customer Meter Inaccuracies</span>
                  <span className="value low">
                    {dashboardData?.meterInaccuracies ? `${dashboardData.meterInaccuracies.toLocaleString('en-US')} m3` : '-'}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="section-dashboard quarter-height t-l">
            <span className="title">Real Losses</span>
            <span className="value">
              {dashboardData?.realLosses ? `${dashboardData.realLosses.toLocaleString('en-US')} m3` : '-'}
            </span>
          </div>
        </div>

        {/* Revenue Water and Non-Revenue Water */}
        <div className="column-dashboard column-other">
          <div className="section-dashboard quarter-height t-b">
            <span className="title">Revenue Water</span>
            <span className="value">
              {dashboardData?.revenueWater ? `${dashboardData.revenueWater.toLocaleString('en-US')} ` : '-'}
            </span>
            <span className="value">
              {dashboardData?.percentageRevenueWater ? `${dashboardData.percentageRevenueWater.toLocaleString('en-US')} %` : '-'}
            </span>
          </div>

          <div className="section-dashboard three-quarters-height t-l">
            <span className="title">Non-revenue Water</span>
            <span className="value">
              {dashboardData?.nonRevenueWater ? `${dashboardData.nonRevenueWater.toLocaleString('en-US')} ` : '-'}
            </span>
            <span className="value">
              {dashboardData?.percentageNonRevenueWater ? `${dashboardData.percentageNonRevenueWater.toLocaleString('en-US')} %` : '-'}
            </span>
          </div>
        </div>
      </div>


    </div>

  );
}
